import { Injectable } from '@angular/core';
import { KpiTableScrollConfig } from './kpi-table-scroll.config';

type KpiScrollWrapper = HTMLElement & { __kpiUpdateScrolled?: () => void };

@Injectable({ providedIn: 'root' })
export class KpisHelper {
  setComparativeHeaderTop(unit: string = null): string | number {
    const kpisSelection = document.querySelector('.kpis-selection') as HTMLElement;
    const topNavbar = document.querySelector('.top-navbar') as HTMLElement;
    const kpisSelectionHeight = kpisSelection?.offsetHeight ?? 0;
    const topNavbarHeight = topNavbar?.offsetHeight ?? 0;
    if (unit) {
      return `${kpisSelectionHeight + topNavbarHeight - 2}${unit}`;
    } else {
      return kpisSelectionHeight + topNavbarHeight - 2;
    }
  }

  /** Tablas de detalle (kpi-realizacion, kpi-stacked, etc.) con primera columna fija. */
  setupKpiDetailTableScroll(idParent: string): void {
    this.setupKpiTableScroll({
      scrollWrapperId: `kpiTableScrollWrapper_${idParent}`,
      tableId: `kpiTable_${idParent}`,
      floatingScrollId: `kpiTableFloatingScroll_${idParent}`,
      widthMirrorId: `kpiTableWidthMirror_${idParent}`,
      columnsBeforeFixed: 0
    });
  }

  /** Configura columna fija y scroll flotante (mismo patrón que DSP). */
  setupKpiTableScroll(config: KpiTableScrollConfig): void {
    setTimeout(() => {
      this.setFixedColumn(
        config.scrollWrapperId,
        config.tableId,
        config.columnsBeforeFixed ?? 0
      );
      this.floatingScroll(
        config.scrollWrapperId,
        config.tableId,
        config.floatingScrollId,
        config.widthMirrorId
      );
    });
  }

  private getKpiHeaderRow(table: HTMLElement): HTMLTableRowElement | null {
    const briefingHeader = table.querySelector<HTMLTableRowElement>('thead tr:has(th.fixed-column)');
    if (briefingHeader) {
      return briefingHeader;
    }

    if (table.classList.contains('first-column-fixed')) {
      return table.querySelector<HTMLTableRowElement>('thead tr:has(th)');
    }

    return (
      table.querySelector<HTMLTableRowElement>('thead tr:has(th):not(.expandable_table_tools)') ??
      table.querySelector<HTMLTableRowElement>('thead tr:first-child')
    );
  }

  private setFixedColumn(scrollWrapperId: string, tableId: string, columnsBeforeFixed: number): void {
    const wrapper = document.getElementById(scrollWrapperId) as KpiScrollWrapper | null;
    const table = document.getElementById(tableId);
    if (!wrapper || !table) {
      return;
    }

    const kpiHeaderRow = this.getKpiHeaderRow(table);
    const headers = kpiHeaderRow?.querySelectorAll('th');
    if (!headers?.length) {
      return;
    }

    let fixedColumnOffset = 0;
    for (let i = 0; i < columnsBeforeFixed; i++) {
      fixedColumnOffset += headers[i].clientWidth;
    }

    const updateScrolledState = () => {
      const isScrolled = columnsBeforeFixed === 0
        ? wrapper.scrollLeft > 0
        : fixedColumnOffset - wrapper.scrollLeft < 1;
      wrapper.classList.toggle('scrolled', isScrolled);
    };

    wrapper.__kpiUpdateScrolled = updateScrolledState;

    if (wrapper.dataset.fixedColumnInit !== 'true') {
      wrapper.dataset.fixedColumnInit = 'true';
      wrapper.addEventListener('scroll', updateScrolledState, { passive: true });
    }

    updateScrolledState();
  }

  private floatingScroll(
    scrollWrapperId: string,
    tableId: string,
    floatingScrollId: string,
    widthMirrorId: string
  ): void {
    const wrapper = document.getElementById(scrollWrapperId) as KpiScrollWrapper | null;
    const table = document.getElementById(tableId);
    const scrollDiv = document.getElementById(floatingScrollId);
    const tableWidthMirror = document.getElementById(widthMirrorId);

    if (!wrapper || !table || !scrollDiv || !tableWidthMirror) {
      return;
    }

    tableWidthMirror.style.width = table.clientWidth + 'px';
    scrollDiv.classList.add('opacity-0');

    if (wrapper.dataset.floatingScrollInit !== 'true') {
      wrapper.dataset.floatingScrollInit = 'true';

      wrapper.addEventListener('scroll', () => {
        scrollDiv.scrollLeft = wrapper.scrollLeft;
        wrapper.__kpiUpdateScrolled?.();
      }, { passive: true });

      scrollDiv.addEventListener('scroll', () => {
        tableWidthMirror.style.width = table.clientWidth + 'px';
        wrapper.scrollLeft = scrollDiv.scrollLeft;
        wrapper.__kpiUpdateScrolled?.();
      }, { passive: true });

      window.addEventListener('scroll', () => {
        if (window.innerHeight - table.getBoundingClientRect().top > 360
          && window.innerHeight - (table.getBoundingClientRect().top + table.clientHeight) < 20) {
          scrollDiv.classList.add('opacity-100');
        } else {
          scrollDiv.classList.remove('opacity-100');
        }
      });
    }

    tableWidthMirror.style.width = table.clientWidth + 'px';
  }
}
